
import React, { useEffect,useState } from "react";
import { Empty,Pagination } from "antd";

import useStatsStore from "../../store/stats.store";
import "./teamTask.scss";
import TeamAssignmentCard from "../TeamAssignmentCard";
import Filter from "../filter";

export default function TeamTaskUpdate(props) {
  const { teamsInternalConsolidatedStats,teamsInternalConsolidatedCount,getTeamsInternalConsolidatedStats} = useStatsStore();

  useEffect(() => {
    //getTeamsInternalConsolidatedStats("24")
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <div className="teamTask-wrapper">
      <div className="teamTask-title"> ({teamsInternalConsolidatedCount || 0}) JDs Found</div>
      <Filter
        filtername = {"getTeamsInternalConsolidatedStats"}
        initDuration={"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"} 
        initClient={"All"}        
        pageNo = {currentPage}
        pageSize ={pageSize}     
        pageHandler = {setCurrentPage}  
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs             
        handleFilter={getTeamsInternalConsolidatedStats}
      />      
      <div></div>      
      {teamsInternalConsolidatedStats?.JDListInternalActivity?.length > 0 ? (
      <>
              {teamsInternalConsolidatedStats?.JDListInternalActivity?.map((jd,idx) => (
                    <TeamAssignmentCard data={jd} index= {idx+1+ (currentPage-1)*pageSize} />
              ))}
      </>
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={teamsInternalConsolidatedCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />       
    </div>
  );
}
